import { useLanguageValue } from './components/LanguageProvider'
import type { Language } from './components/SiteHeader'

/**
 * Die wenigen Texte, die in den gemeinsamen Bauteilen selbst stecken –
 * überwiegend Beschriftungen für Screenreader.
 */
const strings = {
  de: {
    chooseLanguage: 'Sprache wählen',
    homepage: 'vitroconnect Startseite',
    legal: 'Rechtliches',
    nextSection: 'Weiter zum nächsten Abschnitt',
  },
  en: {
    chooseLanguage: 'Choose language',
    homepage: 'vitroconnect homepage',
    legal: 'Legal',
    nextSection: 'Continue to the next section',
  },
} satisfies Record<Language, Record<string, string>>

export type UiStrings = (typeof strings)['de']

export function useUiStrings(): UiStrings {
  const { language } = useLanguageValue()
  return strings[language]
}
